import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaBehance, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const handleMenuClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>C.U Fredson Nigeria</h4>
            <p>Leading Engineering Technology Company providing innovative solutions for construction, mining, and drilling projects across Nigeria.</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/" onClick={handleMenuClick}>Home</Link></li>
              <li><Link to="/about" onClick={handleMenuClick}>About</Link></li>
              <li><Link to="/services" onClick={handleMenuClick}>Services</Link></li>
              <li><Link to="/projects" onClick={handleMenuClick}>Projects</Link></li>
              <li><Link to="/contact" onClick={handleMenuClick}>Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Construction Technology</a></li>
              <li><a href="#services">Mining & Support</a></li>
              <li><a href="#services">Rock Drilling</a></li>
              <li><a href="#services">Blasting Services</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="footer-social">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" title="Facebook">
                <FaFacebook />
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" title="Twitter">
                <FaTwitter />
              </a>
              <a href="https://www.behance.net" target="_blank" rel="noopener noreferrer" title="Behance">
                <FaBehance />
              </a>
              <a href="https://wa.me/+2348034648000" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} C.U Fredson Nigeria Limited. All rights reserved.</p>
          <p className="developer-credit">
            <span>Developed by</span>
            <a href="https://opadatech.com" target="_blank" rel="noopener noreferrer">
              Opadatech
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
